export const redirectToUrl = url => window.location.href = url;
export const isAcceptanceTestPortal = () => document.cookie.includes('hs_selenium');